<template>
    <div id="kpihome">
        <img src="../../assets/imgs/kpi/titlehead.jpeg">
        <div role-name>
            <i></i>
            <p dot-1>●</p>
            <p>{{role}}</p>
            <p dot-2>●</p>
        </div>

        <div grid>
            <ul class="mainmenu">
                <li><a :href="'/#/ToTerminal/'+curUserId"><b><img src="../../assets/imgs/kpi/zjzd.png" /></b><span>直击终端</span></a></li>
                <li><a :href="'/#/kpi/' +curUserId "><b><img src="../../assets/imgs/kpi/scfy.png" /></b><span>市场风云</span></a></li>
                <li><a :href="'/#/workload/'  +curUserId"><b><img src="../../assets/imgs/kpi/nrzd.png" /></b><span>牛人战队</span></a></li>
                <li><a href="#"><b><img src="../../assets/imgs/kpi/sryx.png" /></b><span>深入一线</span></a></li>
                <li><a :href="'/#/performance/'  +curUserId"><b><img src="../../assets/imgs/kpi/grzj.png" /></b><span>个人战绩</span></a></li>
                <li><a href="#"><b><img src="../../assets/imgs/kpi/more.png" /></b><span>更多...</span></a></li>
            </ul>
        </div>

    </div>
</template>
<script>
  import { getBaseUrl } from "../../api/api";

    export default {
        data() {
            return {
                baseUrl:getBaseUrl(),
                curUserId:this.$route.params.uid,
                role:this.$route.params.role,
            };
        },
        mounted() {
        },
        methods: {
        },
    };
</script>

<style scoped>
    #kpihome {
        padding: 12px;
    }

    img {
        display: block;
        width: 100%;
    }

    [role-name] {
        position: relative;
        height: 1.875rem;
        line-height: 1.875rem;
        margin: 20px auto;
        text-align: center;
        width: 70%;
    }

    [role-name] i {
        display: block;
        height: 1px;
        background: rgb(45, 184, 18);
        position: absolute;
        top: 0.95rem;
        width: 100%;
    }

    [role-name] p {
        display: inline-block;
        font-size: 1rem;
        background: #fff;
        text-align: center;
        margin: 0 auto;
        position: relative;
        z-index: 2;
        color: rgb(45, 184, 18);
        font-weight: bold;
        padding: 0 20px;
    }

    [role-name] [dot-1] {
        padding: 0 !important;
        margin-right: -5px;
        font-weight: 100;
        font-size: 3vw;
    }

    [role-name] [dot-2] {
        padding: 0 !important;
        margin-left: -5px;
        font-weight: 100;
        font-size: 3vw;
    }


    .mainmenu {
        list-style: none outside none;
        margin: 0;
        padding: 0;
    }

    .mainmenu li {
        float: left;
        margin-left: 2.5%;
        margin-bottom: 2.5%;
        width: 30%;
        border-radius: 3px;
        overflow: hidden;
    }


    .mainmenu li a {
        display: block;
        color: rgb(45, 184, 18);
        text-align: center;
        text-decoration: none;
        font-size: 14px;
    }

    .mainmenu li a b {
        display: block;
        height: 80px;
    }

    .mainmenu li a img {
        margin: 15px auto 15px;
        width: 70px;
        height: 70px;
    }
</style>


// WEBPACK FOOTER //
// src/components/kpi/KpiHome.vue